import { debug } from '../utils';

export const invokeGpayLocationSpotAPI = async () => {
  debug('INFO', 'Initiating invokeGpayLocationSpotAPI ...');
  const responseToReturn = {};

  const locationApiResponse = await microapps
    .getCurrentLocation()
    .then((locationResponse) => {
      debug('RESPONSE', `GPAY /getCurrentLocation`, locationResponse);

      responseToReturn.statusCode = 200;
      responseToReturn.body = locationResponse;
      return responseToReturn;
    })
    .catch((error) => {
      debug('ERROR', error);
      responseToReturn.statusCode = 500;
      responseToReturn.body = {};
      return responseToReturn;
    });

  return locationApiResponse;
};
